import React, {FC, ReactNode} from 'react';
import {Icon} from '@bonprix/design-system';

interface SupportItemProps {
    icon: string;
    children: ReactNode;
}

const SupportItem: FC<SupportItemProps> = ({icon, children}) => {
    return (
        <div className="flex items-center gap-2.5">
            <Icon className="w-10 h-10" variant={icon} />
            <div className="flex flex-col">{children}</div>
        </div>
    );
};

export default SupportItem;
